import Form from 'react-bootstrap/Form';
import React from 'react';
import humanizeDuration from 'humanize-duration';

export const DEFAULT_TEST_DURATION_IN_MS = 1 * 60 * 1000; // 1 min

const DURATIONS = [
    DEFAULT_TEST_DURATION_IN_MS,
    3 * 60 * 1000, // 3 mins
    5 * 60 * 1000
];

class TestDurationPicker extends React.Component {
    handleTestDurationChange = (event) => {
        const testDuration = event.target.value;
        this.props.onChange(testDuration);
    }

    renderTestDurationOptions() {
        return DURATIONS.map((value) => {
            const label = humanizeDuration(value);
            return (<option key={label} value={value}>{label}</option>);
        });
    }

    render() {
        const {testDuration} = this.props;

        return (
            <Form.Group>
                <Form.Label>Test Duration</Form.Label>
                <Form.Control
                    as='select'
                    value={testDuration}
                    onChange={this.handleTestDurationChange}
                    disabled={this.props.disabled}
                >
                    {this.renderTestDurationOptions()}
                </Form.Control>
            </Form.Group>
        );
    }
}

export default TestDurationPicker;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/component/test-duration-picker.jsx